import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WistiaVideoPlayer from '../../../../../../common/media/WistiaVideoPlayer';

class WebinarOverview extends Component {

    renderMedia(media, url, image){
        if(media === 'video')
        {
            return (
                <WistiaVideoPlayer url={ url }/>
            )
        }
        else
        {
            return (
                <img style={{ width: "100%", position: "relative" }} src={image} alt='webinar'/>
            )
        }
    }
    render() 
    {
        const webinar = this.props.webinarPrismic && this.props.webinarPrismic.webinarsList[0];
        let url = webinar.url
        let image = webinar.image
        return (
            <div className="col-12 col-lg-8 webinar-overview">
            { webinar && this.renderMedia(webinar.media, url, image)}
            </div>
        );
    };
}

WebinarOverview.propTypes = {
    webinar: PropTypes.object.isRequired,
};

export default WebinarOverview;


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/WebinarOverview.js